export default "__VITE_ASSET__BCcBjJys__"